<template>
  <v-card class="px-3" :loading="loading">
    <v-card-text>
      <v-layout row wrap>
        <v-flex xs2>
          <v-checkbox label="Active" v-model="selectActive" value="true" hide-details></v-checkbox>
        </v-flex>
      </v-layout>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  data() {
    return {
      search:null,
      menu1:false,
      menu2:false,
      selectActive:null,
    }
  },
  props:['loading', 'resourceSettings', 'resource', 'time'],
  methods:{
    searchResource() {
      this.$emit('searchResource', this.search)
    },
    create() {
      this.$emit('create')
    },
    buildFilter(){
      let filter = ``
      if(this.selectActive) {
        filter += `&filter[is_prefer]=${this.selectActive}`
      }
      return filter
    },
    filterLeads() {
      this.$emit('filterLeads', this.buildFilter())
    },
    resetFilters() {
      this.fromDate = null
      this.toDate = null
      this.selectedCity = null
      this.selectedState = null
      this.selectedSpecialty = null
      this.selectVerified = null
      this.selectPrefer = null
      this.$emit('filterLeads', this.buildFilter())
    }
  },
  computed:{
    i18n(){
      return this.$store.state.i18n[this.$store.state.language]
    },
    arabic(){
      if(this.$store.state.language == 'ar') return true
    },
  }
}
</script>

<style>
.specialCheckBoxes .v-input--selection-controls {
    margin-top: unset;
    padding-top: unset;
}
</style>